import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Weine vor der Verkostung kühlen!`}</p>
    <p>{`Weiß- und Schaumweine 8-12 °C`}</p>
    <p>{`Rotweine 16-18 °C`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      